'use client';
import React, { useState } from 'react';
import Styles from './progressive-sign-lease.module.scss';
import Button from '../../../../components/button';
import { Modal } from '~/components/modal';
import ProgressiveLeaseSignIframe from './progressive-lease-sign-iframe';
import {
  useSetPaymentReview,
  useProgressiveDetails,
  useSetProgressiveDetails,
  useOrderInProgress,
  useSetOrderInProgress,
  usePaymentConnectorId,
  useCartId,
} from '~/store/wmap-store';
import checkoutDeleteTransactionAction from '../utils/progressive-submit-actions';
import { ISalesOrderResponse } from '~/interfaces/get-sales-order';
import { submitProgressiveOrder } from '~/utils/payment/submit-progressive-order';
import { useRouter } from 'next/navigation';
import { WMAP_PREFIX } from '../../constants';

const ProgressiveSignLease: React.FC<{
  orderDetails: ISalesOrderResponse;
}> = ({ orderDetails }) => {
  const progressiveDetails = useProgressiveDetails();
  const setProgressiveDetails = useSetProgressiveDetails();
  const setPaymentReview = useSetPaymentReview();
  const orderInProgress = useOrderInProgress();
  const setOrderInProgress = useSetOrderInProgress();
  const cartId = useCartId();
  const paymentConnectorId = usePaymentConnectorId();

  const [signingModal, setSigningModal] = useState<boolean>(false);
  const router = useRouter();

  const toggleSignModal = () => {
    if (!orderInProgress) {
      void checkoutDeleteTransactionAction(
        progressiveDetails?.LeaseDetails?.ApplicationId,
      );
    }
    setSigningModal(false);
    setProgressiveDetails({});
    setPaymentReview({
      review: false,
    });
  };
  const handleIFrameMessage = submitProgressiveOrder({
    paymentConnectorId,
    cartId,
    orderDetails,
    progressiveDetails,
    router,
    setOrderInProgress,
    toggleSignModal,
  });

  const getDocuSignIFrame = () => (
    <div className={Styles.docuSignBody}>
      <ProgressiveLeaseSignIframe
        iframeAriaLabel={''}
        sourceUrl={progressiveDetails?.ESignUrl}
        height={'100%'}
        width={'100%'}
        displayContent={''}
        css={''}
        onIFrameMessage={handleIFrameMessage}
        progLeaseID={'121'}
      />
    </div>
  );

  const signingButtonId = `${WMAP_PREFIX}-progressive-sign-lease-btn`;
  return (
    <>
      <div className={Styles.progressiveSubmitWrapper}>
        <Button onClick={() => setSigningModal(true)} id={signingButtonId}>
          Sign Lease & Submit Order
        </Button>
      </div>
      {signingModal && (
        <Modal
          headerTitle="Progressive Leasing"
          modalBody={getDocuSignIFrame()}
          isOpen={signingModal}
          toggleModal={toggleSignModal}
        />
      )}
    </>
  );
};

export default ProgressiveSignLease;
